import { useToast } from "@/state/ToastContext"
import { Icon } from "./Icon"

/** Toast stack: errors are also announced to screen readers. */
export function Toasts() {
  const { toasts, dismiss } = useToast()
  return (
    <div className="toast-stack" aria-live="polite" aria-atomic="false">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast toast-${toast.kind}`} role={toast.kind === "error" ? "alert" : "status"}>
          <Icon
            name={toast.kind === "success" ? "check" : toast.kind === "error" ? "alert" : "info"}
            size={16}
          />
          <div className="toast-content">
            <p>{toast.message}</p>
            {toast.detail && <p className="toast-detail">{toast.detail}</p>}
          </div>
          <button type="button" className="icon-button small" onClick={() => dismiss(toast.id)} aria-label="Dismiss">
            <Icon name="x" size={14} />
          </button>
        </div>
      ))}
    </div>
  )
}
